/* Neyli : quand on change de coloris, les miniatures de la galerie sont remises à jour
   pour n'afficher que les photos du coloris choisi (ordre et visibilité identiques au rendu serveur). */
(function () {
  if (window.__neilyVariantMedia) return;
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  window.__neilyVariantMedia = true;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = event && event.data;
    if (!data || !data.html) return;

    data.html.querySelectorAll('media-gallery .thumbnail-list').forEach(function (newList) {
      var list = newList.id ? document.getElementById(newList.id) : null;
      if (!list) return;
      newList.querySelectorAll('li[data-target]').forEach(function (src) {
        var li = list.querySelector('li[data-target="' + src.dataset.target + '"]');
        if (!li) return;
        li.className = src.className;
        if (src.dataset.mediaPosition) li.dataset.mediaPosition = src.dataset.mediaPosition;
        list.appendChild(li);
      });
      var slider = list.closest('slider-component');
      if (slider && typeof slider.resetPages === 'function') slider.resetPages();
    });

    data.html.querySelectorAll('media-gallery .slider-counter--total').forEach(function (newTotal) {
      var gallery = newTotal.closest('media-gallery');
      var current = gallery && gallery.id ? document.getElementById(gallery.id) : null;
      var total = current && current.querySelector('.slider-counter--total');
      if (total) total.textContent = newTotal.textContent;
    });
  });
})();
